export default __webpack_public_path__ + "05cbc3e30d132a872dd28939d0034324.svg";